import { render, staticRenderFns } from "./settingBankAccount.vue?vue&type=template&id=168af7d2&"
import script from "./settingBankAccount.vue?vue&type=script&lang=js&"
export * from "./settingBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports